import { useEffect, useState } from "react";

export default function AjuanMobile() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);

  const fetchData = async () => {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/ajuan?page=${page}`);
    const result = await res.json();

    setData((prev) => [...prev, ...result.data]);
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  // infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 200
      ) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="space-y-4 min-h-screen">
      {data.map((item, index) => (
        <div
          key={index}
          className={`bg-white p-4 rounded-2xl shadow-sm border active:scale-[0.98] transition-all duration-200 ${item.read === 'read' ? 'border-gray-100' : 'border-gray-700'}`}
        >
          {/* HEADER */}
          <div className="flex justify-between items-start">
            <h2 className="font-semibold text-[15px] text-gray-800 leading-snug">
              {item.note}
            </h2>

            <div className="flex items-center gap-1 text-xs px-2 py-1 rounded-full bg-blue-50 text-blue-600">
              <span className="w-2 h-2 rounded-full bg-blue-500"></span>
              {item.read}
            </div>
          </div>

          {/* BODY */}
          <div className="mt-3 flex justify-between items-end">
            <div>
              <p className="text-base font-semibold text-gray-900">
                Rp {item.total}
              </p>
              <p className="text-xs text-gray-400 mt-1">
                {item.tanggal_final}
              </p>
            </div>

            {/* ACTION */}
            <button className="text-xs bg-gray-900 text-white px-4 py-1.5 rounded-full hover:bg-gray-800 transition">
              Detail
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}